import api from './api';

export const InstitutionsRevenueAPI = {
  getTotalInstitutionRevenue: (params = {}) => api.get('/institution_revenues', { params }),
  getCoursesIncomForInstitution: (id, params = {}) => api.get(`/institution_revenues/${id}/paid_courses`, { params })
};
